import type {IAttributes, IAugmentedJQuery, INgModelController, IScope} from 'angular';
import type {KpPdfViewerControlPanelComponentCommands, KpPdfViewerControlPanelComponentController} from './kp-pdf-viewer-control-panel.component';
import KpPdfViewerControlPanelComponent from './kp-pdf-viewer-control-panel.component';

export function buildCommandDirective(commandName: keyof KpPdfViewerControlPanelComponentCommands) {
    return class {
        public require = `^${KpPdfViewerControlPanelComponent.componentName}`;

        public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes, controller: KpPdfViewerControlPanelComponentController) {
            const handler = () => $scope.$apply(() => controller[commandName]());

            $element.on('click', handler);

            $scope.$on('$destroy', () => $element.off('click', handler));
        }
    };
}

export class KpPdfViewerControlPanelCurrentPage {
    public static directiveName = 'kpPdfViewerControlPanelCurrentPage';

    public require = ['ngModel', `^${KpPdfViewerControlPanelComponent.componentName}`];

    public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes, [ngModelController, pdfViewerController]: [INgModelController, KpPdfViewerControlPanelComponentController]) {
        $scope.$watch(() => pdfViewerController.currentPage, () => {
            ngModelController.$setViewValue(pdfViewerController.currentPage);
            ngModelController.$render();
        });

        $scope.$watch(() => ngModelController.$viewValue, (value) => {

            pdfViewerController.currentPageChange(parseInt(value, 10));
        });
    }
}

/**
 * @ngdoc directive
 * @name kpPdfViewerControlPanelZoomIn
 * @module portaro.components.pdf-viewer
 *
 * @description
 *
 */

/**
 * @ngdoc directive
 * @name kpPdfViewerControlPanelZoomOut
 * @module portaro.components.pdf-viewer
 *
 * @description
 *
 */

/**
 * @ngdoc directive
 * @name kpPdfViewerControlPanelFitAuto
 * @module portaro.components.pdf-viewer
 *
 * @description
 *
 */

/**
 * @ngdoc directive
 * @name kpPdfViewerControlPanelFitWidth
 * @module portaro.components.pdf-viewer
 *
 * @description
 *
 */
